import axios from 'axios';
import urls from "../../../urls/config";

const hrmMethods = {
    fetchPositions(departmentId) {
        return axios.get(urls.hrm.fetchPositions.url.replace(':id', departmentId))
            .then(response => {
                return response.data.data;
            }).catch(()=>{});
    }
};
export default hrmMethods;
